import { Component, OnInit, EventEmitter, Output, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'swb-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.scss']
})
export class FilterListComponent implements OnInit {
  @ViewChild('filter') input;

  public opened = false;
  public focused = false;
  public query = '';

  @Output()
  public modelChange = new EventEmitter<string>();

  @Input()
  public bgColor: string;

  constructor() { }

  ngOnInit() {
  }


  public triggerClick(): void {
    this.opened = !this.opened;
    if (!this.opened) {
      this.query = '';
      this.modelChange.emit('');
    } else {
      this.input.nativeElement.focus();
    }
  }

  public focus(): void {
    this.focused = true;
  }

  public blur(): void {
    this.focused = false;
  }

  public change(query: string) {
    this.modelChange.emit(query);
  }

  public getStyle(): any {
    if (typeof this.bgColor !== 'undefined') {
      return { 'background-color': this.bgColor };
    }
    return {};
  }

}
